import { render, staticRenderFns } from "./ComplaintCreationSummary.vue?vue&type=template&id=6a0bddca&scoped=true&lang=pug&"
import script from "./ComplaintCreationSummary.vue?vue&type=script&lang=ts&"
export * from "./ComplaintCreationSummary.vue?vue&type=script&lang=ts&"
import style0 from "./ComplaintCreationSummary.vue?vue&type=style&index=0&id=6a0bddca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0bddca",
  null
  
)

export default component.exports